import React, { useEffect, useMemo, useRef, useState } from "react";
import classes from "./CallCard.module.css";
import WarningIcon from "@material-ui/icons/Warning";
import { connect } from "react-redux";
import { withAuth0 } from "@auth0/auth0-react";
import { faUser } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import InfoIcon from '@mui/icons-material/Info';
import { ClearError, UserName } from "../../redux-store/actions";
import { useDispatch, useSelector } from "react-redux";
import {
    SetSelectedWorkdeskConversation,
    CallSourceFunc,
    MobileNumberFunc,
    ResposneOfCallFunc,
    SetError,
    showingLoadingBarFunc,
    centerSelectFunc,
    centerPreFixFunc,
} from "../../redux-store/actions";
import PersonIcon from "@material-ui/icons/Person";
import { useAuth0 } from "@auth0/auth0-react";
import QuestionAnswerIcon from "@material-ui/icons/QuestionAnswer";
import ComputerIcon from '@mui/icons-material/Computer';
import moment from "moment-timezone";

const CallCard = ({
    center_id,
    conversation_id,
    caller_id,
    mobile_number,
    updated_mob_number,
    center_prefix,
    center_name,
    initiate_time,
    call_status,
    status_code,
    referral_form_status,
    Call_escalate,
    ClearErrorForDisplay,
    referral_counter,
    reducerStatusCode,
    SelectedConversationId,
    operatorName,
    operatorEmail,
    oerderSaved,
    operator_name,
    operator_nickname,
    updatedDataSend,
    initiator_source,
    clientSideMessage,
    watch_list,
    componentIdentity,
    CallTakenByOperator,
    OperatorWatchlist,
    demographic_status,
    isReferralFormFetching,
    reduxCenterName,
    reduxCenterPrefix,
    centerSelectFunc,
    centerPreFixFunc,
    bot_error,
    appointment_to_be_booked_manually,
    bp_appointment_id,
    is_recording_available,
    ereferral_uid,
    call_closed_at_last_state,
    language_code,
    callStatusFilter,
    webbot_conversation_device,
    center_timezone,
    server_timezone,
    operator_feedback,
    conversation_context,
    client_ip
}) => {
    const state = useSelector((state) => state);
    const { user } = useAuth0();
    const previousConversationIdRef = useRef(null);
    // Center was becoming the undefine (UnKnown reason), to set the center in redux we used this
    useEffect(() => {
        if (conversation_id !== SelectedConversationId) {
            return;
        }
        if (center_name && center_name !== reduxCenterName) {
            centerSelectFunc(center_name);
        }
        if (center_prefix && center_prefix !== reduxCenterPrefix) {
            centerPreFixFunc(center_prefix);
        }
    }, [
        conversation_id,
        SelectedConversationId,
        center_name,
        center_prefix,
        reduxCenterName,
        reduxCenterPrefix,
        centerSelectFunc,
        centerPreFixFunc,
    ]);

    useEffect(() => {
        if (SelectedConversationId) {
            previousConversationIdRef.current = SelectedConversationId;
        }
    }, [SelectedConversationId]);
    
    const convertServerTimeIntoLocalTime=(initiate_time,server_timezone,center_timezone)=>{
        if(server_timezone && center_timezone && initiate_time){
            const momentServer = moment.tz(initiate_time, server_timezone);
        // Convert to target timezone
        const momentTarget = momentServer.clone().tz(center_timezone);
        // Format the result as required
        const formattedTime = momentTarget.format('YYYY-MM-DDTHH:mm:ss');
        return formattedTime;
        }else{
            return initiate_time
        }
        
    }
    const center_time = useMemo(
        () => convertServerTimeIntoLocalTime(initiate_time, server_timezone, center_timezone),
        [initiate_time, server_timezone, center_timezone]
    );
    
    // console.log("IDNAME   mobile_number", mobile_number);
    // console.log("jsonMsg  IDNAME   caller_id", caller_id);
    // console.log("jsonMsg Conversation Id", conversation_id);

    const PatientsMobileNo = () => {

        if (updated_mob_number != undefined) {
            return <span>{updated_mob_number}</span>;
        } else {
            return <span>{caller_id} </span>
        }
    };
    let Status_code_InString = JSON.stringify(status_code);

    let referral_counter_Instring = JSON.stringify(referral_counter);

    const dispatch = useDispatch();
    let style = [classes.callCard];



    if (call_closed_at_last_state === 1 && status_code == null) {

        if ((initiator_source == "LANDLINE" || initiator_source == "MOBILE" || initiator_source == "PBX" || initiator_source == "PRIVATE") && is_recording_available == true) { style.push(classes.complete_order); }

        else if (initiator_source === "CHAT" || initiator_source === "WEBBOT" || initiator_source === "CHATTY" || initiator_source === "MANUAL" || initiator_source === "KIOSK") { style.push(classes.complete_order); }

        const index = style.indexOf(classes.active);
        if (index > -1) {
            style.splice(index, 1);
        }



    }
    //NOTE:- checking the if clicked is true than show notification that response did not come of this call
    if (state.SelectedConversationId === conversation_id) {
        style.push(classes.active);
        if (call_closed_at_last_state === 1 && status_code == null) {
            const index = style.indexOf(classes.complete_order);
            if (index > -1) {
                style.splice(index, 1);
            }
        }
    }
    // if (initiator_source === "CHAT" || initiator_source === "WEBBOT" || initiator_source === "CHATTY") {
    //     helperSetCallCompleteStyle(call_status, status_code, style, state, conversation_id);
    // }
    // else if ((initiator_source == "LANDLINE" || initiator_source == "MOBILE" || initiator_source == "PBX" || initiator_source == "PRIVATE") && is_recording_available == true)
    // {
    //     helperSetCallCompleteStyle(call_status, status_code, style, state, conversation_id);
    // }

    const ConversationSelected = (
        conversation_id,
        caller_id,
        center_name,
        referral_form_status,
        initial_time,
        center_time,
        operatorName,
        client_ip
    ) => {
        if (state.is_Any_Datafetching_Request_InProgress === true || isReferralFormFetching === true) {
            // dispatch(showingLoadingBarFunc(true));
            return;
        }

        ClearErrorForDisplay();
        dispatch(
            SetSelectedWorkdeskConversation({
                conversation_id: conversation_id,
                caller_id: caller_id,
                center_name: center_name,
                referral_form_status: referral_form_status,
                initial_time: initial_time,
                center_prefix: center_prefix,
                center_id: center_id,
                client_ip: client_ip
            })
        );
        if (!mobile_number) {
            dispatch(MobileNumberFunc(""));
        }

        //NOTE:- Here we are storing the initiator_source detail in the redux store
        dispatch(CallSourceFunc(initiator_source));

        if (clientSideMessage !== undefined) {
            clientSideMessage({
                conversation_id: conversation_id,
                operator_id: operatorEmail,
                event: "CURRENT_OPERATOR",
            });
        }

        const previousConversationId = previousConversationIdRef.current;
        if (
            previousConversationId &&
            previousConversationId !== conversation_id &&
            clientSideMessage !== undefined
        ) {
            clientSideMessage({
                conversation_id: previousConversationId,
                operator_id: operatorEmail,
                event: "UPDATE_OPERATOR",
            });
        }
        previousConversationIdRef.current = conversation_id;
    };

    const Style = {
        backgroundColor: referral_form_status === "Pending" ? "red" : "green",
        // width: "33px",
        color: "white",
        height: "14px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        position: "relative",
        top: "0px",
        float: "right",
        zIndex: "2",
        fontSize: "8px",
        marginLeft: "1px",
        right: "-2px",
    };

    const showInProgressIcon = () => {
        if (call_status === "IN_PROGRESS") {
            return (
                <div>
                    <p className="Beep"></p>
                </div>
            );
        }
    };

    const showAttentionRequiredIcon = () => {
        if (
            (call_status === "ESCALATED" && status_code == null) ||
            Call_escalate === "Escalate"
        ) {
            return (
                <div>
                    <WarningIcon
                        className="Beep_Esclate"
                        style={{ color: "red", fontSize: "20px" }}
                    />
                </div>
            );
        }
        else if (call_status === "IN_PROGRESS") {
            return (
                <div>
                    <p className="Beep"></p>
                </div>
            );

        }
        // commenting the M (manual Flag)

        // else if (appointment_to_be_booked_manually){
        //   return (
        //     <div>
        //       <p className="" style={{width:"15px", height:"15px ", background:bp_appointment_id ?"green":"red", textAlign:"center",fontWeight:"bold",color:"white"}}>M</p>
        //     </div>
        //   );

        // }


        else {
            return (
                ""
            );
        }
    };

    const showBotErrorIndicator = () => {
        return (
            <div>
                {bot_error && call_status === "ESCALATED" ?

                    <div style={{ display: "flex" }}>

                        <InfoIcon style={{ color: "#f57242", fontSize: "18px" }} />
                        <WarningIcon
                            className="Beep_Esclate"
                            style={{ color: "red", fontSize: "18px" }}
                        />
                    </div>
                    :
                    <InfoIcon style={{ color: "#f57242", fontSize: "20px" }} />
                }
            </div>
        );
    }


    const referralCounter = {
        fontSize: "8px",
        backgroundColor: "gray",
        borderRadius: "50%",
        width: "15px",
        height: "15px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        marginLeft: "5px",
        color: "white",
    };

    const userStyle = {
        PersonIcon: {
            width: 10,
            color: "red",
        },
    };
    const operatorNameFunc = () => {
        if ((operator_name !== undefined && operator_nickname !== undefined) && (operator_name !== null && operator_nickname !== null)) {
            return (
                <span title={operator_name}>
                    <span
                        style={{
                            fontWeight: "bolder",
                            paddingLeft: "6px",
                            fontSize: "10px",
                            // width: "5px",
                            // height: "5px",
                            color: "black",
                            marginRight: "2px",
                        }}
                    >
                        <FontAwesomeIcon icon={faUser} />
                    </span>
                    <span style={{ fontWeight: 800, color: "black" }}>
                        {operator_nickname}
                    </span>
                    {
                        initiator_source === "DIRECT_CALL" ? <span style={{ marginLeft: "10px" }}>[DIRECT CALL]</span> : ""

                    }

                    {/* {operator_nickname} */}
                </span>
            );
        } else {
            return <span>{""}</span>;
        }
    };


    const operatorWatchListContent = useMemo(() => {
        if (watch_list !== undefined) {
            return watch_list.map((item, index) => {
                if (index == 0) {
                    return (
                        <span
                            style={{ color: "white", backgroundColor: "#04B962" }}
                            title={item.operator_name}
                        >
                            {item.operator_nickname}
                        </span>
                    );
                } else {
                    return (
                        <span
                            style={{ color: "white", backgroundColor: "#04B962" }}
                            title={item.operator_name}
                        >
                            ,{item.operator_nickname}
                        </span>
                    );
                }
            });
        }
        else {
            return <span>{""}</span>;
        }
    }, [watch_list]);

    //NOTE:- this function shows the call source Icon based on the initiator_source
    const showCallIcon = () => {
        if (initiator_source === "CHAT" || initiator_source === "WEBBOT" || initiator_source === "CHATTY") {
            return (
                <QuestionAnswerIcon
                    style={{ height: "20px", width: "20px" }}
                ></QuestionAnswerIcon>
            );
        } else if (initiator_source == "LANDLINE" || initiator_source == "MOBILE" || initiator_source == "PBX" || initiator_source == "PRIVATE") {
            return (
                <img
                    src={process.env.PUBLIC_URL + "/assets/images/phone-call.svg"}
                    alt="phoneIcon"
                />
            );
        } else if (initiator_source === "MANUAL") {
            return <PersonIcon style={{ fontSize: "17px" }} />;
        }
        else if (initiator_source === "KIOSK") {
            return <ComputerIcon style={{ fontSize: "17px" }} />;
        }
        else {
            return "";
        }
    };

    const showEreferralIcon = () => {
        if (ereferral_uid !== null && ereferral_uid !== undefined) {
            return (
                <img
                    src={process.env.PUBLIC_URL + "/assets/images/ereferral-logo.png"}
                    alt="EreferralIcon"
                />

                // <ArticleIcon
                //     style={{ height: "20px", width: "20px" }}
                // ></ArticleIcon>
            )
        }
    }

    const ShowCenterName = ({ center_prefix, center_name }) => {


        if (center_name && center_name.toLowerCase() === "center not selected") {
            if (center_prefix) return `${center_prefix}-${center_name}`
            return `${center_name}`
        } else if (center_name && center_name.toLowerCase() !== "center not selected") {
            if (center_prefix) return `${center_prefix}-${center_name}`
            return `${center_name}`

        } else return ""


    }

    return (
        <>
            <div
                id={"call-" + conversation_id}
                className={style.join(" ")}
                onClick={() =>
                    ConversationSelected(
                        conversation_id,
                        // is_referral_present,
                        caller_id,
                        center_name,
                        referral_form_status,
                        initiate_time,
                        operatorName,
                        center_time,
                        client_ip
                    )

                }
                style={{
                    cursor: "pointer",
                    // background: clickedCall === conversation_id ? "#F7882B" : "#ADDEE6",
                }}
            // style={call_complete}
            >
                {/* <p>{status_code}</p> */}
                <p
                    style={{
                        marginLeft: "3px",
                        display: "flex",
                        justifyContent: "space-between",
                        marginBottom: "0px",
                    }}
                >
                    { user?.oi_profile && user?.oi_profile?.toLowerCase() !== "customer" && <span>{operatorNameFunc()}</span>}
                    <p>{watch_list !== undefined && <>{operatorWatchListContent}</>}</p>
                </p>
                <table className={classes.callCardTable}>
                    <tr>
                        <td className={classes.icon}>{showCallIcon()} <div>{showEreferralIcon()}</div>
                        </td>
                        <td>
                            <div style={{ fontWeight: "800", display: "flex", justifyContent: "space-between" }}>
                            <div style={{display:"flex",gap:"3px"}}>
                            <PatientsMobileNo updated_mob_number={updated_mob_number} />
                             
                           {webbot_conversation_device!=null &&
                           <div style={{  fontWeight: "normal" }}>({webbot_conversation_device.charAt(0).toUpperCase() + webbot_conversation_device.slice(1).toLowerCase()})</div>
                           } </div>
                              
                                {language_code !== "en" && <span style={{ fontStyle: "italic", fontWeight: "normal" }}>({language_code})</span>}
                            </div>
                            <div>
                                <ShowCenterName center_prefix={center_prefix} center_name={center_name} />
                                {/* {center_prefix}
                {center_prefix != null &&
                  center_prefix !== undefined &&
                  center_prefix.length !== 0 &&
                  "-"}
                {center_name} */}
                                { }



                            </div>
                            {center_time != initiate_time &&
                                <div style={{ padding: "2px 0px" }}>
                                    {new Date(center_time).toLocaleString("en-US", {
                                        year: "numeric",
                                        month: "short",
                                        day: "numeric",
                                        hour: "numeric",
                                        minute: "numeric",
                                    })} (local)
                                </div>
                            }

                            {<div>
                                {new Date(initiate_time).toLocaleString("en-US", {
                                    year: "numeric",
                                    month: "short",
                                    day: "numeric",
                                    hour: "numeric",
                                    minute: "numeric",
                                })} 
                            </div>}
                            
                            <span
                                style={{
                                    float: "right",
                                    fontSize: "7px",
                                    fontStyle: "italic",
                                }}
                            >
                                {Status_code_InString !== undefined &&
                                    // ReducerStatusCode !== undefined &&
                                    // ReducerStatusCode !== null &&
                                    Status_code_InString !== null &&
                                    Status_code_InString !== "" &&
                                    (Status_code_InString == "1007" ||
                                        Status_code_InString === "3005" ||
                                        Status_code_InString === "2006" ||
                                        Status_code_InString === 3005 ||
                                        Status_code_InString === 2006 ||
                                        Status_code_InString == 1007) && <p> test Call</p>}
                            </span>
                        </td>
                        <td
                            style={{
                                verticalAlign: "top",
                                paddingRight: "5px",
                                paddingTop: "5px",
                            }}
                        >
                            {/* {showInProgressIcon()} */}
                            {bot_error ? showBotErrorIndicator() : showAttentionRequiredIcon()}
                            {/* {showAttentionRequiredIcon()} */}
                        </td>
                    </tr>
                </table>
                { user?.oi_profile && user?.oi_profile?.toLowerCase() !== "customer"  &&
                <div>
                {referral_form_status === "Available" &&
                    (ereferral_uid === null ||
                        (ereferral_uid !== null && (
                            call_status === 'CALL_COMPLETE' ||
                            (status_code && [1001, 1002, 1004, 1007, 2004, 3007].includes(status_code))
                        ))) && (
                        <div style={Style}>Ref. Available</div>
                    )}
                {(referral_form_status === "Processed") && (
                    <div style={Style}>Ref. Processed</div>
                )}
                {referral_form_status === "Pending" && (
                    <div style={{ display: "flex", float: "right" }}>
                        <div style={Style}>Ref. Pending</div>
                        {referral_counter_Instring !== "null" &&
                            referral_counter_Instring !== undefined &&
                            referral_counter_Instring !== "0" && (
                                <p style={referralCounter}>{referral_counter_Instring}</p>
                            )}
                    </div>
                )}
                {referral_form_status === "Referral_re_request" && (
                    <div style={{ display: "flex", float: "right" }}>
                        <div
                            style={{
                                backgroundColor: "red",
                                color: "white",
                                height: "14px",
                                justifyContent: "center",
                                display: "flex",
                                alignItems: "center",
                                position: "relative",
                                top: "0px",
                                float: "right",
                                zIndex: "2",
                                fontSize: "7px",
                            }}
                        >
                            Ref.Re_request
                        </div>
                        {referral_counter_Instring !== "null" &&
                            referral_counter_Instring !== undefined &&
                            referral_counter_Instring !== "0" && (
                                <p style={referralCounter}>{referral_counter_Instring}</p>
                            )}
                    </div>
                )}
                </div>
                }
                {/* Checking the demographic_status key value is Pending  */}
                {demographic_status === "DEMOGRAPHICS_PENDING" && (
                    <div
                        style={{
                            backgroundColor: "red",
                            color: "white",
                            height: "14px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",

                            position: "relative",
                            top: "0px",
                            float: "right",
                            zIndex: "2",
                            fontSize: "7px",
                        }}
                    >
                        Demographic_Correction
                    </div>
                )}
                {/* Checking the demographic_status key value is Available*/}
                {demographic_status === "DEMOGRAPHICS_AVAILABLE" && (
                    <div
                        style={{
                            backgroundColor: "green",
                            color: "white",
                            height: "14px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            position: "relative",
                            top: "0px",
                            float: "right",
                            zIndex: "2",
                            fontSize: "8px",
                        }}
                    >
                        Demographic_Available
                    </div>
                )}
                {user?.oi_profile && user?.oi_profile?.toLowerCase() === "customer"  && 
                <div>
              {operator_feedback && !conversation_context  && <div style={{display:"flex",justifyContent:"flex-end",paddingRight:"15px"}}>Invalid Call</div>}
              {conversation_context=="MISCELLANEOUS"  && <div style={{display:"flex",justifyContent:"flex-end",paddingRight:"15px"}}>Non Booking</div> }
              {operator_feedback==1005 && <div style={{display:"flex",color:"red",fontWeight:"600",justifyContent:"flex-end",paddingRight:"15px",fontSize:"9px"}} >Processing Error</div> }
                </div> }
        
                { user?.oi_profile && user?.oi_profile?.toLowerCase() === "customer"  && operator_feedback &&
                <div style={{display:"flex",justifyContent:"flex-end"}}>
                 <div className={classes.operator_feedback} >
              {conversation_context=="CANCEL_APPOINTMENT"  && <div style={{fontSize:"10px"}}>Cancellation</div> }
              {conversation_context=="MODIFY_APPOINTMENT"  && <div  className={classes.reschedule} >Rescheduled</div> }
              {conversation_context=="BOOK_APPOINTMENT" && <div>
              {operator_feedback==1001 && <div className={classes.ai_success} >Success</div> }
              {[2004,2003, 2007,2008].includes(operator_feedback) && <div className={classes.hangup_attended} >Hangup Attended</div> }
              {operator_feedback==2005  && <div className={classes.hangup}>Hangup</div> }
              {[3004, 3007].includes(operator_feedback) && <div className={classes.escalated}>Escalated</div> }
              {[1007,2006, 3005].includes(operator_feedback) && <div className={classes.test_call}>Test Call</div> }
                </div>}
             </div>   
                </div>
             }  
            </div>
        </>
    );
};

const mapStateToProps = (state) => {
    return {
        errorForDisplay: state.Error,
        reducerStatusCode: state.statusCode,
        SelectedConversationId: state.SelectedConversationId,
        operatorName: state.operatorName,
        operatorEmail: state.operatorEmail,
        CallTakenByOperator: state.CallTakenByOperator,
        OperatorWatchList: state.OperatorWatchlist,
        isReferralFormFetching: state.isReferralFormFetching,
        WebSocket: state.WebSocket,

        reduxCenterName: state.Center,
        reduxCenterPrefix: state.CenterPrefix,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        ClearErrorForDisplay: () => dispatch(ClearError()),
        centerSelectFunc: (data) => dispatch(centerSelectFunc(data)),
        centerPreFixFunc: (data) => dispatch(centerPreFixFunc(data)),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withAuth0(CallCard));

function helperSetCallCompleteStyle(call_status, status_code, style, state, conversation_id) {
    if (call_status === 'CALL_COMPLETE' && status_code == null) {
        style.push(classes.complete_order);
        const index = style.indexOf(classes.active);
        if (index > -1) {
            style.splice(index, 1);
        }



    }
    //NOTE:- checking the if clicked is true than show notification that response did not come of this call
    if (state.SelectedConversationId === conversation_id) {
        style.push(classes.active);
        if (call_status === 'CALL_COMPLETE' && status_code == null) {
            const index = style.indexOf(classes.complete_order);
            if (index > -1) {
                style.splice(index, 1);
            }
        }
    }
}

